export default "__VITE_ASSET__CDf1Adnh__"